// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__WFZuv","list":"BalanceDue_list__3q60m","listRow":"BalanceDue_listRow__3Eec9","total":"BalanceDue_total__1DJib"};